import { useGetCarbonProgramByFarmId } from "utils";

import { CROPS_METHODOLOGY } from "models";

export const useCropMethodology = (farmId: string) => {
  const { data } = useGetCarbonProgramByFarmId(farmId);
  const crops = data?.farmLevelFootprinting?.methodology?.crops;
  return {
    // no methodology defaults to Klim
    isKlim: !crops || crops === CROPS_METHODOLOGY.KLIM,
    isCfp: crops === CROPS_METHODOLOGY.CFP,
  };
};
